/**
 * Gets the referral code from cookie (key: referral_code) set by nationalfinanceolympiad.com.
 * Cookies are accessible when the checkout runs on the same domain or subdomain
 * (e.g., nationalfinanceolympiad.com or checkout.nationalfinanceolympiad.com).
 */
export const getReferralCodeFromCookie = (): string | null => {
  if (typeof document === "undefined") return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; referral_code=`);
  console.log("parts", parts);
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(";").shift()?.trim();
    return cookieValue || null;
  }
  return null;
};

/**
 * Gets the referral code from URL params (referredBy) or falls back to cookie (referral_code).
 * Use this to get the referral code when it may come from either source.
 */
export const getReferralCode = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const fromUrl = urlParams.get("referredBy");
  if (fromUrl) return fromUrl;
  return getReferralCodeFromCookie();
};
